import { RequestFloorDTO } from '@/dto/responseDto/request-floor.dto';
import httpAdmin from '@/httpCommon/axiosClient';

class RoomTypeService {
    getAll = async () => {
        const res = await httpAdmin.get('/phong/loai_phong');
        return res?.data;
    };

    delete = async (id: string | number) => {
        const res = await httpAdmin.delete(`/phong/loai_phong/${id}`);
        return res?.data;
    };

    create = async (body: RequestFloorDTO) => {
        const res = await httpAdmin.post('/phong/loai_phong', body);
        return res?.data;
    };

    update = async (id: string | number, body: RequestFloorDTO) => {
        const res = await httpAdmin.put(`/phong/loai_phong/${id}`, body);
        return res?.data;
    };

    detail = async (id: string) => {
        const res = await httpAdmin.get(`/phong/loai_phong/${id}`);
        return res?.data;
    };
}
export default new RoomTypeService();
